import { dynamoAttachmentBytes } from '../chat/projectDynamo'
import { Icon } from '../ui/Icon'
import { useBlobUrl } from '../ui/useBlobUrl'
import { openBoardOn } from './boardNav'
import { showArea, type MessageArea } from './area'

/**
 * A question about an area of a whiteboard, in the chat (board/area.ts): the message names its board AND the area,
 * and shows the picture that went with it. Pressing either opens that board on that area, with the box drawn round it
 * again — the box itself left the board when the question went, so this is where it is found.
 */
function open(conv: string, board: string, area: MessageArea, text: string) {
  showArea({ conv, board, area: { x: area.x, y: area.y, w: area.w, h: area.h }, text })
  openBoardOn(conv, board)
}

export function AreaChip({ conv, board, boardName, area, text }: { conv: string; board: string; boardName: string; area: MessageArea; text: string }) {
  return (
    <button type="button" className="pmsg-board pmsg-area" title="Asked about an area of this whiteboard — show it" onClick={() => open(conv, board, area, text)}>
      <Icon name="highlight_alt" size={12} />
      <span>{boardName} · area</span>
    </button>
  )
}

/** The area's picture under the question: what the person boxed, as they saw it. */
export function AreaPicture({ conv, board, area, text }: { conv: string; board: string; area: MessageArea; text: string }) {
  const shot = area.shot
  const { url, failed } = useBlobUrl(shot ? () => dynamoAttachmentBytes(conv, shot) : null, [shot])
  if (!shot || failed) return null
  return (
    <button type="button" className="pmsg-area-pic" title="Show this area on the whiteboard" onClick={() => open(conv, board, area, text)}>
      {url ? <img src={url} alt="The area of the whiteboard this asks about" /> : <span className="pmsg-area-wait">Loading the picture…</span>}
    </button>
  )
}
